import { IPlinkoState } from './IPlinkoState';

export const initialPlinkoState: IPlinkoState = {
    purchasableTokensRemaining: 0,
    isRewardAnimationComplete: false,
};
